import {Flex, Spinner, Text, VStack} from "@chakra-ui/react"
import {useTranslation} from "react-i18next";

function Loading(props) {
    const { t } = useTranslation();
    const { ...rest } = props;

    return (
        <Flex h="100vh" justify="center" align="center" { ...rest }>
            <VStack spacing={4}>
                <Spinner size="xl" />
                <Text fontSize="lg" fontWeight="bold" color="gray.600">
                    {t('loading')}
                </Text>
            </VStack>
        </Flex>
    )
}

export default Loading;